import errorHandler from './errorHandler';

export default {
    mixins: [errorHandler],

    data: () => ({
        model: null,
        defaults: {},
        source: null,
        data: {},
        loading: true,
    }),

    computed: {
        isEditing: vm => !!vm.$route.params.id,
    },

    methods: {
        async load() {
            if (this.$v) {
                this.$v.$reset();
            }

            this.loading = true;
            this.$Progress.start();

            try {
                if (this.isEditing) {
                    this.defaults.id = this.$route.params.id;
                    const data = this.defaults;
                    this.source = await this.model.find(this.$route.params.id);

                    Object.keys(this.$v.data).forEach((k) => {
                        if (k.substr(0, 1) === '$') {
                            return;
                        }

                        data[k] = this.source[k];
                    });

                    this.data = new this.model(data);
                } else {
                    this.data = new this.model(this.defaults);
                }

                this.$Progress.finish();
            } catch (err) {
                this.catchError('Ladefehler', 'Die benötigten Daten konnte nicht geladen werden', err);
                this.$Progress.fail();
            } finally {
                this.loading = false;
            }
        },

        async saveForm() {
            this.$v.$reset();
            this.$v.$touch();

            if (this.$v.$pending || this.$v.$error) {
                this.$nextTick(() => {
                    this.$scrollTo('.parsley-errors-list', 500, {
                        offset: -200,
                    });
                });

                return false;
            }

            this.loading = true;

            try {
                if (this.preSave) {
                    await this.preSave();
                }

                await this.data.save();

                this.$store.dispatch('notifications/add', {
                    color: 'success',
                    title: 'Gespeichert!',
                    description: 'Die Daten wurden erfolgreich gespeichert.',
                });

                this.$emit('reload');

                return true;
            } catch (err) {
                this.catchError(
                    'Fehler beim Speichern',
                    'Die Daten konnten nicht gespeichert werden.',
                    err,
                );

                return false;
            } finally {
                this.loading = false;
            }
        },
    },

    watch: {
        $route() {
            this.load();
        },
    },

    created() {
        this.load();
    },

    mounted() {
        this.$scrollTo('#app');
    },
};
